<template>
    <div v-if="this.buttons" class="btn-group col-12 col-md-6 mb-3" role="group" aria-label="">
        <Button v-for="s in stages" :key="s.stage" 
            :name="s.name" 
            :id="'st_' + s.stage"
            v-on:click="this.updateStage(s.stage)"
            :type='s.stage == this.stage ? "btn-success" : "btn-outline-success"'
        />       
    </div>
    <div v-else class='stage' :class="{ 'justify-content-center mb24': !vertical, 'stages-with-content': stagesWithContent }">
        <div class='stage-wrapper flex-row' :class="{ 'flex-column align-items-start': this.vertical, 'w-100': this.stagesWithContent }">
            <div  
                v-for="s in stages" 
                :key="s.stage" 
                :id="'st_' + s.stage" 
                class="stage-wrapper-single" 
                v-on:click='!stagesWithContent ? this.updateStage(s.stage) : null' 
                :class="{ 'action': s.stage == (stagesWithContent ? activeStageByStatus : this.stage), 
                    'w-100': this.stagesWithContent, 
                    'non-interactive': stagesWithContent,
                    'time-expired-stage': s.stage === activeStageByStatus && timeExpired
                }"
            >
                <div class="d-flex" :class="{ 'flex-column align-items-start': this.vertical, 'align-items-center': !this.vertical, 'time-expired-stage': s.stage === activeStageByStatus && timeExpired }">
                    <div class="stage-item flex-row" :class="{ '': vertical}">
                        <span class="stage-num"
                            :class="{ 'complete': s.ready && !(s.stage === activeStageByStatus && timeExpired), 
                                'time-expired': s.stage === activeStageByStatus && timeExpired, 
                            }"
                        >
                            <span v-if="s.stage === activeStageByStatus && timeExpired">
                                <Icon name="timeline-time-is-up" class="c16" />
                            </span>
                            <span v-else-if="!s.ready" class="neue">{{ 1 + Number(s.stage) }}</span>
                            <Icon v-else name="check-mark" class="c16" />
                        </span>
                        <div :class="{ 'pointer': !stagesWithContent, 'w-100': this.stagesWithContent }">
                            <div class="d-flex justify-content-between align-items-center w-100">
                                <p class="mb-0 text-black neue" :class="{'lh24': !stagesWithContent, 'lh32': stagesWithContent}">
                                    {{ s.name }}
                                </p>
                                <div v-if="titleWithContent !== false && titleWithContent !== undefined && (Array.isArray(titleWithContent) ? titleWithContent.includes(s.stage) : s.stage === titleWithContent)" class="title-content-slot">
                                    <slot name="titleContent" :stage="s.stage" :stageName="s.name"></slot>
                                </div>
                            </div>
                            <div v-if="!stagesWithContent" class="fsp14 primary-grey neue-roman" :class="{ 'color-notification-green': s.ready }">
                                {{ s.stage === this.stage && !s.ready ? $t('components.virtAct.Stages.1') : s.ready ? $t('components.virtAct.Stages.2') : $t('components.virtAct.Stages.3') }}
                            </div>
                            <div v-if="stagesWithContent && s.stage <= (stagesWithContent ? activeStageByStatus : this.stage)" class="stage-content-slot mt16 w-100">
                                <slot :stage="s.stage" :stageName="s.name"></slot>
                            </div>
                        </div>
                    </div>
                    <div v-if="1 + Number(s.stage) < stages.length" class="line mt8">
                        <div 
                            class="line-item" 
                            :class="{ 
                                'filled': s.ready && stages[s.stage].ready && !(s.stage === activeStageByStatus && timeExpired), 
                                'empty': (!s.ready && s.stage !== stage) && !stages[s.stage].ready,
                                'vertical': vertical,
                                'short': shortElement,
                                'time-expired': s.stage === activeStageByStatus && timeExpired
                            }" 
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
import Button from '@/components/service/Button';
import Icon from '@/components/icons/Icon.vue';
import ProgressStages from './CircleStages.vue';

export default {
    components: {
        Button,
        Icon,
        ProgressStages
    },
    props: {
        stages: Array,
        stage: [Number, String],
        buttons: [Boolean],
        vertical: [Boolean],
        shortElement: [Boolean],
        stagesWithContent: [Boolean],
        titleWithContent: [Number, Boolean, Array],
        swapStatus: [Number, String],
        timeExpired: [Boolean]
    },
    data() {
        return {
            act: false,
            w: true,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 1000
        },
        activeStageByStatus() {
            if (!this.stagesWithContent || !this.swapStatus) {
                return this.stage;
            }
            
            // Определяем активную стадию на основе статуса свопа
            const status = Number(this.swapStatus);

            if (status === 50 || status === 60) {
                return this.stage;
            }

            if (status === 10) return 0;
            if (status === 20) return 1;
            if (status === 30) return 2;
            
            return this.stage; // Fallback к переданной стадии
        },
    },
    methods: {
        updateStage(i) {
            this.$emit('updateParentState', i)
        },
    },
}
</script>

<style lang="scss" scoped>
    .line {
        margin-left: 14px;

        .line-item {
            height: 4px;
            width: 64px;
            border-radius: 4px;
            background: linear-gradient(to right, $color-notification 10%,$primary-stroke 60%);
            
            &.vertical {
                height: 64px;
                width: 4px;
                background: linear-gradient($color-notification 10%,$primary-stroke 60%);

                &.short {
                    height: 24px;
                }
            }

            &.empty {
                background: $primary-stroke;
            }
            
            &.filled {
                background: $color-notification;
            }

            &.time-expired {
                background: $dark-orange;
            }
        }
    }
    .stage {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        height: max-content;

        &-item {
            display: flex;
            align-items: center;
        }

        &-num {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            background-color: $primary-stroke;
            color: $primary-grey;
            border-radius: 50%;
            cursor: pointer;
            margin-right: 16px;
            flex-shrink: 0;
            
            &.complete {
                color: white;
                background-color: $color-notification; 
            }

            &.time-expired {
                color: white;
                background-color: $dark-orange;
                border-color: $dark-orange;
            }
        }
        &-wrapper {
            display: flex;
            flex-direction: column;
            gap: 10px;
            .action {
                .stage-num:not(.time-expired) {
                    color: white;
                    background-color: $color-notification;
                }
            }
        }
        
        &-wrapper-single {
            &.non-interactive {
                cursor: default;
                
                .stage-num {
                    cursor: default;
                }
            }
        }
    }

// Стили только для режима с контентом - кастомная линия
.stages-with-content {
    .stage-wrapper {
        gap: 24px;
    }
    .stage-wrapper-single {
        position: relative;
        width: 100%;
        
        // Убираем Grid, возвращаем обычный flex
        .d-flex {
            align-items: flex-start;
            width: 100%;
        }
        
        .stage-item {
            align-items: flex-start;
            width: 100%;
        }
        
        .pointer {
            width: 100%;
        }
        
        .stage-content-slot {
            width: 100%;
            margin-top: 16px;
        }
        

        &::after {
            content: '';
            position: absolute;
            left: 16px; // Центр круга
            top: 40px; // После круга
            width: 4px;
            background: linear-gradient($color-notification 10%,$primary-stroke 60%);
            border-radius: 4px;
            z-index: 1;
            
            // Базовая высота для этапов без контента
            height: 8px;
        }

        &:has(.stage-content-slot).time-expired-stage::after {
            background: linear-gradient($dark-orange 10%,$primary-stroke 60%);
        }

        // Для этапа с контентом - увеличиваем высоту кастомной линии
        &:has(.stage-content-slot)::after {
            height: calc(100% - 40px); // По высоте контейнера
        }

        // Убираем линию для последнего этапа
        &:last-child::after {
            display: none;
        }
    }
    
    // Убираем стандартную линию
    .line {
        display: none !important;
    }
}
</style>